// extracted by mini-css-extract-plugin
export default {"label":"radio-button_label__vUkcu","radioLabel":"radio-button_radioLabel__LSxJi"};